import { Component, OnInit, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { ApiService } from 'src/app/services/api/api.service';
import { ModalService } from '../modal.service';

@Component({
  selector: 'app-modal-image-capture',
  templateUrl: './modal-image-capture.component.html',
  styleUrls: ['./modal-image-capture.component.scss']
})
export class ModalImageCaptureComponent implements OnInit {

  @ViewChild('imageCaptureModal', {static: false}) modal;
  modalRef: BsModalRef;
  configmodal = {
    class: 'modal-dialog-centered modal-lg', 
    ignoreBackdropClick: true, 
    keyboard: false,
    animated: false
  };
  image: any = '';
  imgFile: any;
  croppedImage: any = '';
  callback: Function;
  isShow = false;

  constructor(
    private modalServ: ModalService,
    private modalService: BsModalService,
    private api: ApiService
  ) { }

  ngOnInit() {
    this.modalServ.onImageCapture.subscribe(req => {
      this.callback = req.callback; 
      if(req.image) {
        this.fileChangeEvent(req.image);
      }

      if(req.imgFile) {
        this.imgFile = req.imgFile;
      }

      if(req.imgUrl) {
        this.editImageUrl(req.imgUrl);
      }
      if(!this.isShow) {this.show();}
    });

    this.modalServ.onImageCaptureHide.subscribe(req => {
      this.hide();
    });
  }

  show() {
    if(this.modalRef){
      this.modalRef.hide();
    }
    this.isShow = true;
    this.modalRef = this.modalService.show(this.modal, this.configmodal);
  }

  hide() {
    if(this.modalRef){
      this.modalRef.hide();
      this.isShow = false;
    }
  }

  fileChangeEvent(event: any): void {
    const size = (event.srcElement.files[0].size / 1000) / 1000;
    // console.log(size);
    if (size >= 19.07) {
      // this.img = null;
      // this.alert.alertError({ title: 'You can only select image up to 19.07 MB in size' });
      console.log('You can only select image up to 19.07 MB in size');
      return;
    } else {
      this.image = event;
    }
  }

  imageCropped(event: ImageCroppedEvent) {
      this.croppedImage = event.base64;
      // this.eventsService.selectedImageSuccess.emit(this.croppedImage);
      // if(!this.isConfirm) {
      //   this.confirmCropped.emit(this.croppedImage);
      // }
  }

  confirm() {
    this.callback(this.croppedImage);
    this.hide();
  }

  imageLoaded() {
    // show cropper
  }

  cropperReady() {
    // cropper ready
  }

  loadImageFailed() {
    // show message
    console.log("Load image fail.");
  }

  async editImageUrl(imageUrl: any) {
    if(imageUrl.indexOf('http') > -1) {
      let url = encodeURI(imageUrl);
      this.api.getImage(url).subscribe(res => {
        if(res.Code == 200) {
          this.imgFile = 'data:'+res.Results;
        }
      }, err => {
        console.log(err);
      });
    }
  }

}
